import { useMemo } from "react";
import Breadcrumb from "./Breadcrumb";
import useBreadcrumbs from "./useBreadcrumbs";

function Breadcrumbs() {
	const { breadcrumbs } = useBreadcrumbs();
	const items = useMemo(() => {
		return (breadcrumbs || []).map((b, i) => ({
			...(typeof b === "object" ? b : { label: b }),
		}));
	}, [breadcrumbs]);
	return (
		<nav
			aria-label="breadcrumb"
			className="flex min-w-0 items-center overflow-hidden whitespace-nowrap p-4 text-secondary"
		>
			{items.map((b, i) => (
				<Breadcrumb key={i} index={i} {...b} />
			))}
		</nav>
	);
}

export default Breadcrumbs;
